var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pt-hospital-form',{ref:"form",staticClass:"pt-hospital-form__withData",attrs:{"company":_vm.company,"rolesList":_vm.rolesList,"hospitalDetail":_vm.hospitalDetail,"isEdit":_vm.isEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }